var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-detail"},[_c('van-nav-bar',{attrs:{"title":this.$route.meta.title,"left-text":"返回","left-arrow":"","fixed":""},on:{"click-left":_vm.onClickLeft}}),_c('router-view',{staticClass:"detail-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }